<template>
  <div class="col-span-full flex flex-col">
    <h2 class="text-t5 mb-6">Granska</h2>
      <div class="col-span-full flex flex-col  lg:col-span-4 rounded-[4px] bg-gray-10 px-2 py-2 pb-4 ring-1 ring-gray-light">
        <div class="flex justify-between mt-2 items-center"><h4 class="text-t6">Var är felet?</h4>
          <div class="flex gap-1 justify-center items-center">
            <Button class="text-turquoise-60 text-button-small" variant="text" size="small" @click="() => goWhere('vart-ar-felet')">
              Ändra
            </Button>
          </div>
        </div>
        <div class="flex flex-col gap-2">
          <div
            v-if="location"
            class="text-b2"
          >
            {{ location.name }}
          </div>
          <div
            v-if="area"
            class="text-b2"
          >
            {{ area.name }}
          </div>
          <div
            v-if="contract"
            class="text-b2"
          >
            {{ contract.name }}
          </div>

        </div>

        <div class="flex justify-between mt-4 items-center"><h4 class="text-t6">Vad är fel? </h4><div class="flex gap-1 justify-center items-center">
          <Button class="text-turquoise-60 text-button-small" variant="text" size="small" @click="() => goWhere('valj-detalj')">
            Ändra
          </Button>
        </div></div>
        <div class="flex flex-col gap-2">
          <div
            v-if="part"
            class="text-b2"
          >
            {{ part.name }}
          </div>
          <div
            v-if="subPart"
            class="text-b2"
          >
            {{ subPart.name }}
          </div>
        </div>
      <div v-if="description" class="col-span-full flex flex-col lg:col-span-4 mt-4">
        <div class="flex justify-between items-center"><h4 class="text-t6">Beskrivning</h4><div class="flex gap-1 justify-center items-center">
          <Button class="text-turquoise-60 text-button-small" variant="text" size="small" @click="() => goWhere('beskrivning')">
            Ändra
          </Button>
        </div></div>
        <div class="text-b2">
          {{ description }}
        </div>
      </div>
      <div v-if="photos && photos.length" class="col-span-full flex flex-col gap-2 lg:col-span-2 mt-4">
        <div class="flex justify-between items-center"><h4 class="text-t6">Foto</h4><div class="flex gap-1 justify-center items-center">
          <Button class="text-turquoise-60 text-button-small" variant="text" size="small" @click="() => goWhere('fotografier')">
            Ändra
          </Button>
        </div></div>

        <div class="flex gap-2 flex-wrap">
          <div v-if="!!photos.length" v-for="(preview, index) in photos" class="relative">
            <img :src="preview" class="w-[144px] h-auto rounded-[8px]" />
           </div>
        </div>
      </div>
      <div v-if="draft && draft.access && draft.access.masterKey!=null" class="col-span-full flex flex-col gap-2 lg:col-span-2 mt-4">
        <div class="flex justify-between items-center"><h4 class="text-t6">Tillträde</h4><div class="flex gap-1 justify-center items-center">
          <Button class="text-turquoise-60 text-button-small" variant="text" size="small" @click="() => goWhere('tilltrade')">
            Ändra
          </Button>
        </div></div>

          <div class="text-b2">
            <span v-if="draft.access.masterKey == 'call'">Ring före på tel: {{draft.access.phoneNumber}}. Nås lättast mellan {{draft.access.callBetween.from}} - {{draft.access.callBetween.to}}</span>
            <span v-else-if="draft.access.masterKey == 'outside'">Utanför lägenheten</span>
            <span v-else>Gå in med huvudnyckel</span>
          </div>
          <div class="text-b2" v-if='draft.pet && draft.pet.pet'>
            <span v-if="draft.pet && draft.pet.pet != 'notstated'">Husdjur: {{petOptions?.name}}</span>
            <span v-else-if="draft.pet">Husdjur: Nej</span>
          </div>
      </div>
    </div>

<!--    <div class="mb-4 rounded-[4px] bg-primary-10 py-2 px-4 mt-4 w-fit text-b2" v-if="email">
      Du får en bekräftelse på <span class="italic">{{email || "din e-postadress"}}</span>  att vi har tagit emot din felanmälan på din e-post.
    </div>-->

  </div>
</template>

<script>
import Loader from '@/components/ui/loader';
import { CONTRACT_STATUSES } from '@/config/constants';
import Button from '@/components/ui/button';
import { getMappedValue } from '@/helpers/mapper';

export default {
  components: { Loader, Button },
  props: {
    rowId: {
      type: [String, Number],
      required: true,
    },
    draft: {
      type: Object
    },
    goWhere: {
      required: true
    }
  },
  data() {
    return {
      showLoader: true,
      showPhotos: false,
    };
  },
  computed: {
    petOptions() {
      return this.$store.getters.getPetOptions ? this.$store.getters.getPetOptions.find(p => p.value === this.draft.pet.pet) : "";
    },
    selectedArea() {
      if (!this.row.areaCode) return null;
      return this.$store.getters.getErrorReportAreaByCode;
    },

    row() {
      return this.$store.getters.getErrorReportRowById(this.rowId);
    },

    isApartment() {
      if (!this.row) return;
      return this.selectedArea && this.selectedArea.contractTypes.indexOf('apartment') != -1;
    },

    contract() {
      if (!this.row) return null;

      const nrOfContractsOfSelectedType = this.$store.getters.getContracts
        .filter((c) => {
          // Filterar ut de kontrakt som inte är av OK status
          return [
            CONTRACT_STATUSES.VALID,
            CONTRACT_STATUSES.PRELIMINARILYTERMINATED,
            CONTRACT_STATUSES.TERMINATED,
          ].some((s) => s == c.status);
        })
        .map((c) => {
          return c.rentalObjectType;
        })
        .filter((c) => this.selectedArea).length;

      // Om man bara har ett kontrakt av den valda typen ska det inte visas.
      if (nrOfContractsOfSelectedType == 1) return;

      const contracts = this.$store.getters.getApartmentContracts;

      return contracts.find(c => c.value === this.row.rentalObjectCode);

    },

    area() {
      if (!this.row || !this.row.areaCode) return;

      // Finns det bara ett val, behöver det inte presenteras
      if (this.$store.getters.getBaseCategories && this.$store.getters.getBaseCategories.length == 1) return;
      return this.$store.getters.getBaseCategories.find(c => c.value === this.row.areaCode);
    },

    location() {
      if (!this.row || !this.row.locationCode) return;

      // Finns det bara ett val, behöver det inte presenteras
      if (this.$store.getters.getErrorReportAreas && this.$store.getters.getErrorReportAreas.length == 1) return;

      return this.$store.getters.getErrorReportAreas.find(c => c.roomTypeCode === this.row.locationCode);

    },

    part() {
      if (!this.row && this.row.partCode) return;
      let areaCode = this.row.areaCode;
      let p = null;
     // if ((getMappedValue(areaCode) == 'apartment' && areaCode != 'outdoor' && areaCode != 'storagearea') || areaCode == 'basement' || areaCode == 'parkingspace' || areaCode == 'playground') p = this.$store.getters.getSubCategories;
     // else if(areaCode == 'storagearea')  p = this.$store.getters.getSubCategories;
     // else p = this.$store.getters.getSubParts;
      p = this.$store.getters.getSubCategories;
      let found = p.find(c => c.id === this.row.partCode || c.id == this.row.locationCode);
      return found ?? this.partCodeName;

    },

    subPart() {
      if (!this.row || !this.row.subPartCode) return;
      let p = this.$store.getters.getSubParts;

      return p.find(c => c.id === this.row.subPartCode);
    },

    description() {
      if (!this.row) return;
      return this.row.description;
    },

    // Använd idn och plocka ut uppladdade
    photos() {
      if (!this.row) return;
      if (!this.row.images || this.row.images.length == 0) return;

      const previews = [];

      this.row.images.forEach((img) => {
        const uploaded = this.$store.getters.getUploadedPhotoById(img.filename);
        if (uploaded) previews.push(uploaded.url);
      });

      return previews;

/*      return this.row.images.map((img) => {
        return this.$store.getters.getUploadedPhotoById(img.filename);
      });*/
    },

    blueprint() {
      if (!this.row) return;
      if (!this.isApartment) return;
      return this.row.blueprint;
    },

    email() {
      const profile = this.$store.getters.profile;
      if (profile && profile.email) return profile.email;
      return;
    },
  },

  watch: {
    'row.images': {
      immediate: true,
      handler(images) {
        if (images && images.length > 0) {
          images.forEach((img) => {
            this.$store.cache.dispatch('fetchUploadedPhoto', img.filename);
          });
        }
      },
    },
  },

  created() {
    this.showLoader = false;
  },
};
</script>

<!-- <div v-if="blueprint">
      <h4 class="text-t6">Markering på ritning</h4>
      <div class="text-b2 rounded-full bg-white px-2 py-1 text-gray-70 ring-1 ring-gray-70">
        Ritning
      </div>
    </div> -->
